export const GET_WISHLIST = 'GET_WISHLIST';
export const GET_WISHLIST_SUCCESS = 'GET_WISHLIST_SUCCESS';
export const GET_WISHLIST_FAIL = 'GET_WISHLIST_FAIL';
export const GET_WISH_DETAIL = 'GET_WISH_DETAIL';
export const GET_WISH_DETAIL_SUCCESS = 'GET_WISH_DETAIL_SUCCESS';
export const GET_WISH_DETAIL_FAIL = 'GET_WISH_DETAIL_FAIL';
export const ADD_WISH = 'ADD_WISH';
export const ADD_WISH_SUCCESS = 'ADD_WISH_SUCCESS';
export const ADD_WISH_FAIL = 'ADD_WISH_FAIL';
export const UPDATE_WISH = 'UPDATE_WISH';
export const UPDATE_WISH_SUCCESS = 'UPDATE_WISH_SUCCESS';
export const UPDATE_WISH_FAIL = 'UPDATE_WISH_FAIL';
export const DELETE_WISH = 'DELETE_WISH';
export const DELETE_WISH_SUCCESS = 'DELETE_WISH_SUCCESS';
export const DELETE_WISH_FAIL = 'DELETE_WISH_FAIL';
export const ADD_UPVOTE_WISH = 'ADD_UPVOTE_WISH';
export const ADD_UPVOTE_WISH_SUCCESS = 'ADD_UPVOTE_WISH_SUCCESS';
export const ADD_UPVOTE_WISH_FAILURE = 'ADD_UPVOTE_WISH_FAILURE';
export const DELETE_UPVOTE_WISH = 'DELETE_UPVOTE_WISH';
export const DELETE_UPVOTE_WISH_SUCCESS = 'DELETE_UPVOTE_WISH_SUCCESS';
export const DELETE_UPVOTE_WISH_FAILURE = 'DELETE_UPVOTE_WISH_FAILURE';
export const ADD_WISH_DETAIL = 'ADD_WISH_DETAIL';
export const REMOVE_WISH_DETAIL = 'REMOVE_WISH_DETAIL';
export const CHANGE_ORDER_TYPE = 'CHANGE_ORDER_TYPE';

export const getWishs = () => ({
  type: GET_WISHLIST
});

export const getWishDetail = (id) => ({
  type: GET_WISH_DETAIL,
  id
});

export const getWishDetailSuccess = (wishDetail) => ({
  type: GET_WISH_DETAIL_SUCCESS,
  wishDetail
});

export const getWishDetailFailure = (error) => ({
  type: GET_WISH_DETAIL_FAIL,
  error
});

export const getWishsSuccess = (wishs) => ({
  type: GET_WISHLIST_SUCCESS,
  wishs
});

export const getWishsFail = (error) => ({
  type: GET_WISHLIST_FAIL,
  error
});

export const addWish = (params) => ({
  type: ADD_WISH,
  params
});

export const addWishSuccess = (wish) => ({
  type: ADD_WISH_SUCCESS,
  wish
});

export const addWishFail = (error) => ({
  type: ADD_WISH_FAIL,
  error
});

export const updateWish = (id, params) => ({
  type: UPDATE_WISH,
  id,
  params
});

export const updateWishSuccess = (wish) => ({
  type: UPDATE_WISH_SUCCESS,
  wish
});

export const updateWishFail = (error) => ({
  type: UPDATE_WISH_FAIL,
  error
});

export const deleteWish = (id) => ({
  type: DELETE_WISH,
  id
});

export const deleteWishSuccess = (id) => ({
  type: DELETE_WISH_SUCCESS,
  id
});

export const deleteWishFail = (error) => ({
  type: DELETE_WISH_FAIL,
  error
});

export const addUpvoteWish = (id) => ({
  type: ADD_UPVOTE_WISH,
  id
});

export const addUpvoteWishSuccess = (wish) => ({
  type: ADD_UPVOTE_WISH_SUCCESS,
  wish
});

export const addUpvoteWishFailure = (error) => ({
  type: ADD_UPVOTE_WISH_FAILURE,
  error
});

export const deleteUpvoteWish = (id) => ({
  type: DELETE_UPVOTE_WISH,
  id
});

export const deleteUpvoteWishSuccess = (wish) => ({
  type: DELETE_UPVOTE_WISH_SUCCESS,
  wish
});

export const deleteUpvoteWishFailure = (error) => ({
  type: DELETE_UPVOTE_WISH_FAILURE,
  error
});

export const addWishDetail = (id) => ({
  type: ADD_WISH_DETAIL,
  id
});

export const removeWishDetail = (id) => ({
  type: REMOVE_WISH_DETAIL,
  id
});

export const changeOrderType = (orderType) => ({
  type: CHANGE_ORDER_TYPE,
  orderType
});
